import { ApplicationConfig, provideAppInitializer, provideZoneChangeDetection } from '@angular/core'
import { provideRouter } from '@angular/router'
import { provideHttpClient, withInterceptors } from '@angular/common/http'
import { provideAnimations } from '@angular/platform-browser/animations'
import { provideNgGlyphs } from '@ng-icons/core'
import { withMaterialSymbolsOutlined } from '@ng-icons/material-symbols'
import { MatPaginatorIntl } from '@angular/material/paginator'
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core'
import { PaginatorIntlService } from '@shared-services/paginator-intl.service'
import { initializeAuthSession } from 'shared/auth/auth-session.initializer'
import { authInterceptor } from 'shared/interceptors/auth.interceptor'

import { viewRoutes } from './view.routes'

export const viewConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimations(),
    provideRouter(viewRoutes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideNativeDateAdapter(),
    { provide: MAT_DATE_LOCALE, useValue: 'es-CO' },
    provideAppInitializer(initializeAuthSession),
    { provide: MatPaginatorIntl, useClass: PaginatorIntlService },
    provideNgGlyphs(withMaterialSymbolsOutlined()),
  ],
}
